import { render, staticRenderFns } from "./NewCharts.vue?vue&type=template&id=a88de3b4&"
import script from "./NewCharts.vue?vue&type=script&lang=js&"
export * from "./NewCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports